import { Alert } from "@mui/material";
import styled from "styled-components";

export const AlertStyles = styled(Alert)`
    font-family: 'Poppins';
`;